import React, { useState, useContext, useEffect, useRef } from "react";
import "../Components/Tickets/Tickets.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { techappContext } from "../../Api/techappReq";
import loadingSvg from "../../assets/images/loadingSvg.svg";
import Loading from "../Components/loading";
import { SendOutlined } from "@ant-design/icons";
// import { Input } from "antd";
import Colors from "../../Helper/Colors";
import Modal from "react-modal";
import uploadIcon from "../../assets/images/upload.png";
import micIcon from "../../assets/images/mic.png";
import stopRecordingIcon from "../../assets/images/stop.png";
import FormatHelper from "../../Helper/FormatHelper";
import { toast } from "react-toastify";
import cameraIcon from "../../assets/images/camera.png";
import galleryIcon from "../../assets/images/gallery.png";
import Camera from "../Components/camera";
import generateKey from "../../utils/generate_key";
import useTicket from "../../hooks/useTicket";
import { AudioRecorder, useAudioRecorder } from "react-audio-voice-recorder";
import { Anchorme } from "react-anchorme";
import Layout from "../../layout";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FaHashtag, FaTimes } from "react-icons/fa";
import { FiCalendar } from "react-icons/fi";
import { IoIosArrowForward, IoIosArrowDown } from "react-icons/io";

// const { TextArea } = Input;

const ViewTicket = () => {
  const textareaRef = useRef(null);
  const ticket = useSelector((state) => state.TechAppReducer.ticketObj);
  const navigate = useNavigate();
  const [showDoc, setShowDoc] = useState(false);
  const [doc, setDoc] = useState(null);
  const [inp, setInp] = useState(null);
  const [imageList, setImageList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [isImageList, setIsImageList] = useState(false);
  const [pickModal, setPickModal] = useState(false);
  const [isCamera, setIsCamera] = useState(false);
  const [voices, setVoices] = useState([]);
  const [commentValue, setCommentValue] = useState("");
  const ticketStatus = useSelector(
    (state) => state.TechAppReducer.ticketStatus
  );

  const {
    startRecording,
    stopRecording,
    recordingBlob,
    isRecording,
    recordingTime,
  } = useAudioRecorder();

  const {
    comments,
    loading,
    sendComment,
    seenTicket,
    seenAnnouncement,
    getBadgesReq,
    sendCommentLoading,
  } = useContext(techappContext);

  const { markTicketsAsSeen } = useTicket();

  const addAudioElement = (blob) => {
    const url = URL.createObjectURL(blob);

    return url;
  };

  const openDoc = (doc) => {
    setShowDoc(true);
    setDoc(doc);
  };

  const upload = (e) => {
    let list = [];
    for (var i = 0; i < e.target.files.length; i++) {
      list.push(e.target.files[i]);
      fileList.push(e.target.files[i]);
    }
    list.forEach((li) => {
      imageList.push(URL.createObjectURL(li));
    });
    setIsImageList(true);
  };

  const removeFileHandler = (url, index) => {
    setImageList(imageList.filter((img) => img !== url));
    setFileList(
      fileList.filter((file, i) => {
        return i !== index;
      })
    );
  };

  const onPreview = async (file) => {
    setDoc(file);
    setShowDoc(true);
  };

  const sendCommentInside = () => {
    if (!localStorage.getItem("auth_from_admin")) {
      if (voices.length === 0 && commentValue.length === 0) {
        toast.warning("لطفا پیام خود را وارد کنید");
      } else {
        sendComment(commentValue, fileList, voices);
        setCommentValue("");
        setFileList([]);
        setImageList([]);
        setVoices([]);
      }
    }
  };

  useEffect(() => {
    if (ticket?.readed === false) {
      if (ticket?.category_id) {
        seenTicket(ticket.id);
      } else {
        seenAnnouncement(ticket.id);
      }
    }
    if (ticket?.id) {
      markTicketsAsSeen([ticket.id]);
    }
    getBadgesReq();
    setCommentValue("");
  }, []);

  useEffect(() => {
    setIsImageList(false);
  }, [isImageList]);

  useEffect(() => {
    if (recordingBlob) {
      voices.push({
        key: generateKey(),
        file: recordingBlob,
        url: window.URL.createObjectURL(recordingBlob),
      });
    }
  }, [recordingBlob]);

  useEffect(() => {
    if (ticketStatus === 0 && ticket?.status !== "Closed") {
      textareaRef.current.style.height = "0px";
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = scrollHeight + "px";
      textareaRef.current.style.marginBottom = scrollHeight - 50 + "px";
    }
  }, [commentValue]);

  return (
    <Layout>
      <>
        <div className="techapp-view-ticket">
          {/* header */}
          <div className="tech-app-header">
            <IoIosArrowForward
              style={{ fontSize: "24px", paddingBottom: "5px" }}
              onClick={() => {
                navigate("/techapp/tickets");
              }}
            />
            <span
              onClick={() => {
                navigate("/techapp/tickets");
              }}
              style={{ marginRight: "10px", cursor: "pointer" }}
            >
              جزییات
            </span>
          </div>
          {ticket ? (
            <>
              {/* ticket infos */}
              <div className="tech-app-view-ticket-detail">
                <span>
                  <IoDocumentTextOutline />
                  {ticket.title}
                </span>
                {ticket.code && (
                  <span>
                    <FaHashtag />
                    {FormatHelper.toPersianString(ticket.code)}
                  </span>
                )}
                {ticket.created_at && (
                  <span>
                    <FiCalendar />
                    {FormatHelper.toPersianString(ticket.created_at)}
                  </span>
                )}
                {ticket.updated_at && (
                  <span>
                    <FiCalendar />
                    {FormatHelper.toPersianString(ticket.updated_at)}
                  </span>
                )}
              </div>
              {/* ticket content */}
              <div className="tech-app-view-ticket-detail">
                <span>توضیحات</span>
                {ticket.message && (
                  <Anchorme
                    target="blank"
                    style={{ textDecoration: "underline" }}
                  >
                    {ticket.message}
                  </Anchorme>
                )}
                {ticket.full_body && (
                  <Anchorme
                    target="blank"
                    style={{ textDecoration: "underline" }}
                  >
                    {ticket.full_body}
                  </Anchorme>
                )}
              </div>
              {/* files preview */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  margin: "25px 0",
                  flexWrap: "wrap",
                  padding: "0 10px",
                }}
              >
                {ticket.files && ticket.files.length > 0 ? (
                  ticket.files.map((doc, index) => {
                    if (
                      doc.full_url.slice(-3) === "mp4" ||
                      doc.full_url.slice(-3) === "mp3"
                    ) {
                      return (
                        <>
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              justifyContent: "space-around",
                              minWidth: "140px",
                              padding: "0 10px",
                              marginBottom: "10px",
                            }}
                          >
                            <video width="100%" height="240" controls>
                              <source src={doc.full_url} type="video/mp4" />
                            </video>
                          </div>
                        </>
                      );
                    } else if (
                      doc.full_url.slice(-3) === "ebm" ||
                      doc.full_url.slice(-3) === "aac"
                    ) {
                      return (
                        <audio
                          key={index}
                          style={{ marginBottom: "10px" }}
                          src={doc.full_url}
                          controls
                        />
                      );
                    } else {
                      return (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "space-around",
                            margin: "0 5px",
                          }}
                        >
                          <img
                            onClick={() => openDoc(doc.full_url)}
                            style={{
                              // width: "15%",
                              height: "80px",
                              objectFit: "cover",
                              width: "80px",
                              margin: "10px 0",
                              cursor: "pointer",
                              borderRadius: "6px",
                            }}
                            src={doc.full_url}
                            alt="docs"
                          />
                        </div>
                      );
                    }
                  })
                ) : (
                  <div></div>
                )}
              </div>
              {/* commnets */}
              {ticketStatus === 0 && (
                <div
                  style={{ boxShadow: "none", paddingBottom: "40px" }}
                  className="tech-app-view-ticket-detail"
                >
                  {comments && comments.length > 0
                    ? comments.map((cm, index) => (
                        <div
                          key={index}
                          style={
                            cm.author === "App\\Models\\Technician"
                              ? { backgroundColor: Colors.royalBlue }
                              : {
                                  backgroundColor: "gray",
                                  marginRight: "auto",
                                  borderRadius: "",
                                }
                          }
                          className={`techapp-ticket-comment-box-default ${
                            cm.author === "App\\Models\\Technician"
                              ? "techapp-ticket-comment-box"
                              : ""
                          }`}
                        >
                          <span>
                            {cm?.comment ? (
                              <Anchorme
                                style={{
                                  color: "white",
                                  textDecoration: "underline",
                                }}
                                target="blank"
                              >
                                {cm.comment}
                              </Anchorme>
                            ) : null}
                          </span>
                          <div style={{ display: "flex", flexWrap: "wrap" }}>
                            {cm.files &&
                              cm.files.length > 0 &&
                              cm.files.map((file, i) => {
                                if (file.full_url.slice(-3) === "mp4") {
                                  return (
                                    <video key={i} width="200" height="120" controls>
                                      <source src={file.full_url} />
                                    </video>
                                  );
                                } else if (
                                  file.full_url.slice(-3) === "ebm" ||
                                  file.full_url.slice(-3) === "aac" ||
                                  file.full_url.slice(-3) === "mp3"
                                ) {
                                  return (
                                    <audio
                                      key={i}
                                      src={file.full_url}
                                      controls
                                      style={{ margin: "5px 0 10px 0" }}
                                    />
                                  );
                                } else {
                                  return (
                                    <img
                                      key={i}
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        marginBottom: "10px",
                                        marginLeft: "5px",
                                        objectFit: "cover",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                      }}
                                      src={file.full_url}
                                      alt="docs"
                                      onClick={() => openDoc(file.full_url)}
                                    />
                                  );
                                }
                              })}
                          </div>
                          <small>
                            {FormatHelper.toPersianString(cm.created_at)}
                          </small>
                        </div>
                      ))
                    : loading && (
                        <Loading title={"در حال بارگذاری پیام ها..."} />
                      )}
                </div>
              )}
              {/* chat area */}
              {ticketStatus === 0 && ticket?.status !== "Closed" && (
                <div className="techapp-chat-input">
                  {(imageList.length > 0 || voices.length > 0) && (
                    <div className="techapp-tickets-filelist-show">
                      {imageList.length > 0 &&
                        imageList.map((url, index) => (
                          <div key={index} style={{ position: "relative" }}>
                            <img
                              onClick={() => onPreview(url)}
                              src={url}
                              id="image-uploaded"
                              key={index}
                              className="techapp-ticket-upload-image"
                              alt={'image'+index}
                            />
                            <span
                              onClick={() => removeFileHandler(url, index)}
                              style={{ left: "-5px" }}
                              className="techapp-upload-remove-btn"
                            >
                              x
                            </span>
                          </div>
                        ))}
                      {voices?.length > 0 &&
                        voices.map((voice, index) => (
                          <div key={index} style={{ position: "relative" }}>
                            <audio src={voice.url} controls />
                            <span
                              onClick={() =>
                                setVoices(
                                  voices.filter((vc) => vc.key !== voice.key)
                                )
                              }
                              style={{ left: "-5px" }}
                              className="techapp-upload-remove-btn"
                            >
                              x
                            </span>
                          </div>
                        ))}
                    </div>
                  )}
                  {/* chat input */}
                  <div className="mv-chat-input-wrapper">
                    {!sendCommentLoading ? (
                      <SendOutlined
                        onClick={sendCommentInside}
                        style={{ cursor: "pointer" }}
                        id="reply_ticket_send_button"
                      />
                    ) : (
                      <img
                        src={loadingSvg}
                        alt="sending"
                        style={{ width: "17px" }}
                      />
                    )}
                    <button
                      style={{
                        background: "transparent",
                        outline: "none",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (!localStorage.getItem("auth_from_admin")) {
                          if (isRecording) {
                            stopRecording();
                          } else {
                            startRecording();
                          }
                        }
                      }}
                    >
                      {isRecording && (
                        <span style={{ marginLeft: "10px", color: "gray" }}>
                          {recordingTime} ثانیه
                        </span>
                      )}
                      <img
                        src={isRecording ? stopRecordingIcon : micIcon}
                        alt="record"
                        style={{ width: "20px" }}
                      />
                    </button>
                    <textarea
                      ref={textareaRef}
                      style={{
                        display: "block",
                        overflow: "hidden",
                        resize: "none",
                        width: "100%",
                      }}
                      disabled={localStorage.getItem("auth_from_admin")}
                      id="reply_ticket_message_input"
                      placeholder="در این قسمت تایپ کنید . . ."
                      value={commentValue}
                      // onPressEnter={sendCommentInside}
                      onChange={(e) => setCommentValue(e.target.value)}
                    />
                    <div style={{ display: "none" }}>
                      <AudioRecorder
                        onRecordingComplete={(blob) => addAudioElement(blob)}
                      />
                    </div>
                  </div>
                  {/* upload image button */}
                  <div
                    className="techapp-ticket-upload"
                    onClick={() => {
                      if (!localStorage.getItem("auth_from_admin")) {
                        setPickModal(true);
                      }
                    }}
                  >
                    <img
                      src={uploadIcon}
                      alt="upload"
                      style={{ width: "25px" }}
                    />
                  </div>
                  <input
                    onChange={upload}
                    type="file"
                    name="filefield"
                    multiple="multiple"
                    style={{ display: "none" }}
                    ref={(fileInput) => setInp(fileInput)}
                  />
                </div>
              )}
            </>
          ) : (
            <img src={loadingSvg} alt="loading" />
          )}
        </div>
        {/* show doc modal */}
        {showDoc && doc && (
          <Modal
            ariaHideApp={false}
            isOpen={true}
            onRequestClose={() => setShowDoc(false)}
            className="tech-app-view-order-showdoc-modal"
            style={{
              overlay: {
                backgroundColor: "rgba(0, 0, 0)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              },
            }}
          >
            <FaTimes
              onClick={() => setShowDoc(false)}
              style={{
                color: "white",
                cursor: "pointer",
                position: "absolute",
                right: "30px",
                top: "20px",
                fontSize: "22px",
              }}
            />
            <img
              style={{ width: "100%", objectFit: "cover" }}
              src={doc}
              alt="doc"
            />
          </Modal>
        )}
        {/* pick modal */}
        <Modal
          ariaHideApp={false}
          isOpen={pickModal}
          onRequestClose={() => setPickModal(false)}
          className="tech-app-view-order-modal"
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.551)",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
              zIndex: "10000",
            },
          }}
        >
          <p style={{ padding: "10px", marginBottom: "20px" }}>
            <IoIosArrowDown
              style={{ cursor: "pointer", padding: "0 10px" }}
              onClick={() => setPickModal(false)}
            />
            <span>انتخاب عکس</span>
          </p>
          <div
            onClick={() => {
              inp.click();
              setPickModal(false);
            }}
            style={{
              color: "black",
              display: "flex",
              alignItems: "center",
              padding: "15px 10px",
              marginBottom: "20px",
            }}
          >
            <img
              src={galleryIcon}
              alt="icon"
              style={{ width: "20px", marginLeft: "10px" }}
            />
            گالری
          </div>
          <div
            onClick={() => {
              if (window.outerWidth > 800) {
                toast.warning(
                  "برای استفاده از دوربین باید از موبایل استفاده کنید"
                );
              } else {
                setIsCamera(true);
                setPickModal(false);
              }
            }}
            style={{
              color: "black",
              display: "flex",
              alignItems: "center",
              padding: "15px 10px",
              marginBottom: "20px",
            }}
          >
            <img
              src={cameraIcon}
              alt="icon"
              style={{ width: "20px", marginLeft: "10px" }}
            />
            دوربین
          </div>
        </Modal>
        {/* camera modal */}
        <Modal
          ariaHideApp={false}
          isOpen={isCamera}
          onRequestClose={() => setPickModal(false)}
          className="tech-app-view-order-modal h-100"
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.551)",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
              zIndex: "10000",
            },
          }}
        >
          <Camera
            modal={setIsCamera}
            fileList={fileList}
            imageList={imageList}
          />
        </Modal>
      </>
    </Layout>
  );
};
export default ViewTicket;
